var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"error-401"},[_c('div',{staticClass:"error-401__message"},[_vm._v("セッションがタイムアウトしました。")]),_c('a',{staticClass:"error-401__link",attrs:{"href":_vm.returnPage}},[_vm._v("戻る")])])
}
var staticRenderFns = []

export { render, staticRenderFns }